import React from 'react'
import { connect,DispatchProp } from 'react-redux'
import { socketConnect } from './index'
import { State } from '../store'
import InfoModal from '../components/Modal'
import { CImg } from '@coreui/react'

type Props =
{
  auth:State['auth']
} & DispatchProp

class WebSocket extends React.PureComponent<Props>
{
  constructor(props:Props)
  {
    super(props)
  }

  componentDidMount()
  {
    socketConnect(this.props.auth,1);
  }

  render()
  {
    return (this.props.auth.user && !this.props.auth.websocket_connected) ?
        <InfoModal
          show={ true }
          onClose={ () => { } }
          header={ <span></span> }
          body={
            <div className="text-center">
              <h2>Loading...</h2>
              {/* <h4 className="my-4">Sorry, something went wrong. Attempting to reconnect to the server.</h4> */}
              {/* <CButton className="btn-info">Take me back</CButton> */}
            </div>
          }
          zindex={ 2 }
        >
        </InfoModal>
        // <h1>Static Loader</h1>
      :(
        <>
      
           
            
       </>
      ) }
}
export default connect((state:State)=>({
  auth:state.auth,
}))(WebSocket)
